module.exports = __webpack_public_path__ + "img/behaviour.877d6c1.jpg";